import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate, openFile, byteSize } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './supplements.reducer';

export const SupplementsDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const supplementsEntity = useAppSelector(state => state.supplements.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="supplementsDetailsHeading">
          <Translate contentKey="fitengineerBackendV2App.supplements.detail.title">Supplements</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{supplementsEntity.id}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="fitengineerBackendV2App.supplements.name">Name</Translate>
            </span>
          </dt>
          <dd>{supplementsEntity.name}</dd>
          <dt>
            <span id="quantity">
              <Translate contentKey="fitengineerBackendV2App.supplements.quantity">Quantity</Translate>
            </span>
          </dt>
          <dd>{supplementsEntity.quantity}</dd>
          <dt>
            <span id="image">
              <Translate contentKey="fitengineerBackendV2App.supplements.image">Image</Translate>
            </span>
          </dt>
          <dd>
            {supplementsEntity.image ? (
              <div>
                {supplementsEntity.imageContentType ? (
                  <a onClick={openFile(supplementsEntity.imageContentType, supplementsEntity.image)}>
                    <img
                      src={`data:${supplementsEntity.imageContentType};base64,${supplementsEntity.image}`}
                      style={{ maxHeight: '30px' }}
                    />
                  </a>
                ) : null}
                <span>
                  {supplementsEntity.imageContentType}, {byteSize(supplementsEntity.image)}
                </span>
              </div>
            ) : null}
          </dd>
          <dt>
            <span id="flavour">
              <Translate contentKey="fitengineerBackendV2App.supplements.flavour">Flavour</Translate>
            </span>
          </dt>
          <dd>{supplementsEntity.flavour}</dd>
          <dt>
            <span id="suitedFor">
              <Translate contentKey="fitengineerBackendV2App.supplements.suitedFor">Suited For</Translate>
            </span>
          </dt>
          <dd>{supplementsEntity.suitedFor}</dd>
          <dt>
            <span id="description">
              <Translate contentKey="fitengineerBackendV2App.supplements.description">Description</Translate>
            </span>
          </dt>
          <dd>{supplementsEntity.description}</dd>
          <dt>
            <span id="image2">
              <Translate contentKey="fitengineerBackendV2App.supplements.image2">Image 2</Translate>
            </span>
          </dt>
          <dd>
            {supplementsEntity.image2 ? (
              <div>
                {supplementsEntity.image2ContentType ? (
                  <a onClick={openFile(supplementsEntity.image2ContentType, supplementsEntity.image2)}>
                    <img
                      src={`data:${supplementsEntity.image2ContentType};base64,${supplementsEntity.image2}`}
                      style={{ maxHeight: '30px' }}
                    />
                  </a>
                ) : null}
                <span>
                  {supplementsEntity.image2ContentType}, {byteSize(supplementsEntity.image2)}
                </span>
              </div>
            ) : null}
          </dd>
          <dt>
            <span id="image3">
              <Translate contentKey="fitengineerBackendV2App.supplements.image3">Image 3</Translate>
            </span>
          </dt>
          <dd>
            {supplementsEntity.image3 ? (
              <div>
                {supplementsEntity.image3ContentType ? (
                  <a onClick={openFile(supplementsEntity.image3ContentType, supplementsEntity.image3)}>
                    <img
                      src={`data:${supplementsEntity.image3ContentType};base64,${supplementsEntity.image3}`}
                      style={{ maxHeight: '30px' }}
                    />
                  </a>
                ) : null}
                <span>
                  {supplementsEntity.image3ContentType}, {byteSize(supplementsEntity.image3)}
                </span>
              </div>
            ) : null}
          </dd>
          <dt>
            <span id="isAvailable">
              <Translate contentKey="fitengineerBackendV2App.supplements.isAvailable">Is Available</Translate>
            </span>
          </dt>
          <dd>{supplementsEntity.isAvailable ? 'true' : 'false'}</dd>
          <dt>
            <span id="price">
              <Translate contentKey="fitengineerBackendV2App.supplements.price">Price</Translate>
            </span>
          </dt>
          <dd>{supplementsEntity.price}</dd>
          <dt>
            <Translate contentKey="fitengineerBackendV2App.supplements.category">Category</Translate>
          </dt>
          <dd>{supplementsEntity.category ? supplementsEntity.category.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/supplements" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/supplements/${supplementsEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default SupplementsDetail;
